module.exports = __webpack_public_path__ + "static/media/temperature-down.298a3740.svg";